// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"278":"c5000f16","567":"a645c7a7","758":"bd7407ba","787":"0bac9acf","851":"cfd65c0d"}[chunkId] + ".chunk.js";
};